/**
* Stats Scroller JS
* -----------------------------------------------------------------------------
*
* All the JS for the Stats Scroller component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'stats-scroller',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      let componentPin = null;
      function loadAnimation() {
        $( '.stats-scroller' ).each( function( key, component ) {
          if ( window.innerWidth >= 1024 ) {
            let navHeight = $( '.navbar' ).height();
            if ( $( '#wpadminbar' ).length ) {
              navHeight += $( '#wpadminbar' ).height();
            }
            navHeight += 'px';

            let totalHeight = 160; // top and bottom padding

            $( component ).find( '.stats-scroller__card' ).each( function( cardKey, card ) {
              totalHeight += $( card ).outerHeight();
              totalHeight += 20; // margin bottom
            } );

            totalHeight -= 20; // last card does not have margin bottom

            componentPin = gsap.timeline( {
              scrollTrigger: {
                trigger: this,
                pin: true,
                start: 'top ' + navHeight,
                end: '+=' + totalHeight,
                onUpdate: function( self ) {
                  if ( self.progress > 0.1 ) {
                    $( component ).find( '.transition-bar--top' ).addClass( 'is-scrolled--top' );
                  }

                  if ( self.progress > 0.9 ) {
                    console.log( 'wefwefew' );
                    $( component ).find( '.transition-bar--bottom' ).addClass( 'is-scrolled--bottom' );
                  }

                  if ( self.progress < 0.1 ) {
                    $( component ).find( '.transition-bar--top' ).removeClass( 'is-scrolled--top' );
                  }

                  if ( self.progress < 0.9 ) {
                    $( component ).find( '.transition-bar--bottom' ).removeClass( 'is-scrolled--bottom' );
                  }
                },
                scrub: 2,
                // markers: true,
              },
            } );

            totalHeight -= $( component ).outerHeight();

            $( component ).find( '.stats-scroller__card' ).each( function( cardKey, card ) {
              componentPin.to( card, {y: '-' + totalHeight + 'px'}, 0 );
            } );
          }
        } );
      }

      if ( window.hasMotion ) {
        loadAnimation();
      }

      ScrollTrigger.refresh( true );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'stats-scroller', COMPONENT );
} )( app );
